<template>
    <div class="condition-wrapper" @click="clickHandler">
        <div class="name-wrapper" @mouseover="hoverHandler(true)" @mouseout="hoverHandler(false)">
            <div class="name" :class="{ 'name-empty': !node.name }" @dblclick="doubleClick">
                <el-tooltip class="item" :content="node.name || '双击编辑「判断条件」'" placement="right-start">
                    <span class="condition-content"> <i class="condition-node" />{{ node.name || "双击编辑「判断条件」" }}</span>
                </el-tooltip>
                <NodeOperateIcon
                    v-show="showOperate"
                    @mouseover="hoverHandler(true)"
                    @mouseout="hoverHandler(false)"
                    @edit="doubleClick"
                    @delete="deleteHandler"
                />
            </div>
        </div>
        <div class="conditions">
            <div class="condition" v-for="(con, index) in conditions" :key="con.conditionId" :id="con.conditionId">
                <el-tooltip :content="condName(con)" placement="right-start">
                    <div>
                        <span class="condition-index">{{ getIndex(index) }}</span>
                        <span class="condition-content ellipsis">{{ condName(con) }}</span>
                    </div>
                </el-tooltip>
                <div class="add-after" @click="afterClick(con, $event)"></div>
            </div>
        </div>
    </div>
</template>

<script>
import NodeOperateIcon from "./common/NodeOperateIcon";
import ConditionEditModal from "./ConditionEdit";

export default {
    name: "Condition",
    props: ["node", "nodes"],
    components: {
        NodeOperateIcon
    },
    data() {
        return {
            showOperate: false
        };
    },
    computed: {
        conditions() {
            return this.node.conditions || [];
        },
        condName() {
            return val => {
                return val.isElse ? "当不满足以上条件时" : val.conditionName;
            };
        }
    },
    methods: {
        clickHandler() {
            // this.$emit("nodeClick", this.node);
        },
        doubleClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: ConditionEditModal,
                data: {
                    title: "设置判断条件",
                    rpaId: this.node.rpaId,
                    nodeId: this.node.id,
                    nodeType: this.node.nodeType,
                    submit: async () => {
                        this.$emit("nodeClick", { node: this.node, operator: "edited" });
                    }
                }
            });
        },
        hoverHandler(flag) {
            this.hoverTimeout && clearTimeout(this.hoverTimeout);
            if (!flag) {
                this.hoverTimeout = setTimeout(() => {
                    this.showOperate = flag;
                }, 500);
                return;
            }
            this.showOperate = flag;
        },
        afterClick(cond, event) {
            this.$emit("connect", { origEvent: event, node: this.node, sourceId: cond.conditionId, type: ["new", "connect"] });
        },
        deleteHandler() {
            this.$emit("nodeClick", { node: this.node, operator: "delete" });
        },
        getIndex(index) {
            return String.fromCharCode("A".charCodeAt() + index);
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) url("./common/rpaNode.less");
.condition-wrapper {
    .rpa-node-wrapper();
    &:hover {
        box-shadow: 0 0 6px 0 #C8D8E5;
    }
}
.name-wrapper {
    .rpa-name-wrapper();
}
.name {
    .rpa-name("@{zhijiStaticImagePath}rpa-node-condition.png");
    .item {
        display: inline-block;
        width: 180px;
    }
}
.name-empty {
    color: #999999;
}
.condition {
    position: relative;
    .rpa-content(#eaf1f8);
    .el-tooltip {
        display: flex;
    }
    .ellipsis {
        width: 164px;
    }
    &:hover {
        border: 1px solid #C8D8E5;
        box-shadow: 0 0 4px 0 #C8D8E5;
        background-color: #F5FAFF;
    }
}
.condition-content {
    .single-line-ellipsis();
}
.condition-index {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    display: flex;
    background: #fff;
    justify-content: center;
    align-items: center;
    color: #c8d8e5;
    font-size: 12px;
    font-weight: bold;
    margin-right: 8px;
}
.add-after {
    position: absolute;
    right: -32px;
    bottom: 10px;
    display: inline-block;
    width: 31px;
    height: 21px;
    background: url("@{zhijiStaticImagePath}add-action-node.png");
}
.condition.jtk-connected {
    .add-after {
        display: none;
    }
}
</style>
